import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
     signinData: null,
    token: localStorage.getItem("token") || null,
    loading: true,
  },
  reducers: {
    setSigninData(state, value) {
      state.signinData = value.payload;
    },
    setToken(state, action) {
      state.token = action.payload;
      state.loading = false;
    },
    clearToken(state) {
      state.token = null;
      state.loading = false;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
});

export const { setSigninData, setToken, setLoading, clearToken } =
  authSlice.actions;
export default authSlice.reducer;
